import { PageWrapper, SeoHead } from 'layouts';
import { EventIds } from 'lib';
import { GetStaticPaths, GetStaticProps, NextPage } from 'next';
import { AuthorProfileQuery } from 'types';
import { logger } from 'utils';
import { AuthorProfile } from 'components';
import { getAuthorProfileData } from 'lib/authors';
import { MappedPost } from 'ui';

export type AuthorPageProps = {
  user: AuthorProfileQuery['user'] | null;
  posts: MappedPost[];
  totalAmountOfPosts: number;
  page: string;
  error: {} | null;
};

export const AuthorPage: NextPage<AuthorPageProps> = (props) => {
  const { user, posts, totalAmountOfPosts, page, error } = props;

  if (!user) {
    return null;
  }

  return (
    <PageWrapper headerColor="white">
      <SeoHead seoHead={user?.seo?.fullHead} />
      <AuthorProfile
        user={user}
        posts={posts}
        totalAmountOfPosts={totalAmountOfPosts}
        page={page}
        error={error}
      ></AuthorProfile>
    </PageWrapper>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  // Variable defined by Vercel project, only on production build (previews won't build everything)
  if (process.env.BUILD_ALL_PAGES !== 'true') {
    return {
      paths: [],
      fallback: 'blocking',
    };
  }

  // TODO: bring back when Apollo is using GET requests
  // const paths = await getAllAuthorsSlugs();

  return { paths: [], fallback: 'blocking' };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { data, error, page, totalAmountOfPosts, posts } =
    await getAuthorProfileData(context);

  if (data !== null && error) {
    logger.error(
      'Getting error on AuthorProfile post fetch',
      EventIds.AuthorProfileError,
      error
    );
  }

  if (data === null) {
    return {
      redirect: {
        destination: context.locale !== 'en' ? `/${context.locale}` : '/',
        permanent: true,
      },
    };
  }

  return {
    props: { user: data.user, posts, totalAmountOfPosts, page, error },
    revalidate: 3600, // 1 hour
  };
};

export default AuthorPage;
